import { useEffect, useState } from 'react';

export const useUnreadMessagesCount = (apiName) => {
    const [count, setCount] = useState(0);

    const api = window?.Communication?.API?.[apiName];

    useEffect(() => {
        let didUnmount = false;

        if (apiName === 'chat') {
            setCount(api?.getUnreadCount()?.adminMessagesCount || 0);
        }

        if (apiName === 'inbox') {
            setCount(api?.getUnreadCount() || 0);
        }

        api?.onUpdateUnreadCount(value => {
            if (didUnmount) {
                return;
            }

            setCount(value);
        });

        return () => {
            didUnmount = true;
        };
    }, [api, apiName]);

    return count;
};
